export default __webpack_public_path__ + "static/media/tercon.8d92af35.png";